const config = {
    questions_in_each_renewal:30
}

module.exports = config;